import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { defaultGridOptions, tooltipDelay, useGridColDefs } from '../../utils/GridUtils';
import { AccordionDetails, AccordionSummary, Button, Tooltip, makeStyles } from '@material-ui/core';
import AnimatedButton from "../../components/UI/AnimatedButton";
import ListAltIcon from "@material-ui/icons/ListAlt";
import { Accordion } from '@mui/material';

import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import DisassociateEmployeeDialog from './DisassociateEmployeeDialog';

const useStyles = makeStyles(theme =>({
  gridActions: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: '1em',
  },

  root : {
    
    '&:hover:not($disabled)': {
      cursor: 'default',
    },
  },
  disabled: {},
}));

const GridActions = ({
  data,
  handleExport,
  loadingExport
}) => {
  const [loadingExportAll, setLoadingExportAll] = useState(false);

  useEffect(() => {
    !loadingExport && setLoadingExportAll(false);
  }, [loadingExport]);

  const exportAll = () => {
    setLoadingExportAll(true);
    handleExport(data.map((r) => r.id));
  };

  return (<AnimatedButton
    variant="contained"
    color="primary"
    size="small"
    startIcon={<ListAltIcon />}
    onClick={exportAll}
    loading={loadingExportAll}
  >
    Exportar grilla
  </AnimatedButton>);
};


const CustomAccordion = ({data}) => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(false)
  
  return(
    <div style={{ display: 'flex', alignItems: 'center' }} >
      
      <Accordion expanded={expanded}  style={{ width: '100%', boxShadow: 'none' }} >
        <AccordionSummary 
          expandIcon={
            data.length > 1 &&
            <Button onClick={() => {setExpanded(!expanded)}} 
              endIcon={!expanded ? 
                <AddBoxOutlinedIcon titleAccess={'Ver más'} />
                : <IndeterminateCheckBoxOutlinedIcon titleAccess='Ver menos'/>}
              color={!expanded ? 'primary' : 'secondary'}
              size='large'
              disabled={data.length < 2}
            >
              {!expanded && <span>{`...+${data.length - 1}`}</span>}
            </Button>
          }
          classes={{ root: classes.root }}

        >
      
          {data.length > 0 ? data[0].split(";")[0] : 'Sin proveedores asociados'} 
      
        </AccordionSummary>
        <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
      
          {data.slice(1).map((supplier, index) => (
            <div key={index} style={{ marginBottom: '5px' }}>
              {supplier.split(";")[0]}
            </div>
          ))}
      
        </AccordionDetails>
      </Accordion>
      
    </div>
    
  );
  
}




const EmployeeGrid = ({data, loading, reloadGrid, gridActions, isAdmin})=>{
  const classes = useStyles();

  const [dialogOpenState, setDialogOpenState] = useState({})

  const handleOpenDialog = (id) => {
    setDialogOpenState(prevState => ({
      ...prevState,
      [id]: true
  }))
  }
  
  const handleCloseDialog = (id) => {
    setDialogOpenState(prevState => ({
      ...prevState,
      [id]: false
  }))
  }

  const colDefs = useGridColDefs(
    isAdmin ? [
    { title: 'Correo', field: 'email' },
    { title: 'Nombre', field: 'name' },
    { 
      title: 'Proveedores Asociados', 
      field: 'supervisingSuppliers',
      render: rowData => <CustomAccordion data={rowData.supervisingSuppliers}/>
    },
    { title: 'Estado', field: 'enabled', valueRender: (value, rowData) => (value ? 'Activo' : 'Inactivo')},
    {
      title: 'Acciones',
      field: 'actions',
      sorting: false,
      valueType: 'icon',
      headerStyle: { textAlign: 'center' },
      valueRender: (value, rowData) => (
        <>
        {!rowData.enabled ? 
          <Tooltip title="Activar" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
            <Button
              aria-label="Activar"
              size="small"
              color="primary"
              onClick={() => {
                gridActions.handleEnable(rowData.id);
              }}
              variant='outlined'
              >
              
                Activar
            </Button>
          </Tooltip> 
          :
          <Tooltip title="Desactivar" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
            <Button
              aria-label="Desactivar"
              size="small"
              color="secondary"
              onClick={() => {
                gridActions.handleDisable(rowData.id)
              }}
              variant='outlined'
              >
                Desactivar
            </Button>
          </Tooltip>
          }
          
          <Button style={{ marginLeft: '5px' }}
              aria-label="Desactivar"
              size="small"
              color="secondary"
              onClick={() => handleOpenDialog(rowData.id)}
              variant='outlined'
              disabled={rowData.supervisingSuppliers.length === 0}
            >
                Desasociar
            </Button>
            <DisassociateEmployeeDialog open={dialogOpenState[rowData.id]} setOpen={() => handleCloseDialog(rowData.id)} employee={rowData} reloadGrid={gridActions.reloadGrid}/>
        </>
      ),
    }]
    :
    [
      { title: 'Correo', field: 'email' },
      { title: 'Nombre', field: 'name' },
      { title: 'Estado', field: 'enabled', valueRender: (value, rowData) => (value ? 'Activo' : 'Inactivo')}
    ]
  );

  return (
    <>
      <div className={classes.gridActions}>
        <GridActions
          data={data}
          {...gridActions}
        />
      </div>
      <div style={{ width: '100%' }}>
        <MaterialTable {...defaultGridOptions} columns={colDefs} data={data} isLoading={loading}/>
      </div>
    </>
  );
}

export default EmployeeGrid;